<dln-date-time-inline class="inline-timer" pickerType="timer"
                      [startAt]="getDate()" (selectedDate)="setNewDate($event?.value)">
</dln-date-time-inline>
